import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";

export default function PrintDesignAndServices() {
  return (
    <div className="Print-Design-And-Services pt-[160px] sm:pt-0 ">
      <Helmet>
        <title>GRAPHIC DESIGNING - Mean3 Software Solutions</title>
      </Helmet>
      <Section1 />
      <Section6 />
      <Section7 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
    </div>
  );
}

